var ApplicantAPI = require("../../api").Applicant;
var LegalStatusesAPI = require('../../api').LegalStatuses;
var OrganisationTypesAPI = require('../../api').OrganisationTypes;
var auth = require('../../auth')
var UserAPI = require('../../api').User;
var Promise = require("bluebird");
var _ = require("underscore");
var Diff = require("../../../common/utils/object-diff.js");
var ApplicantLegalStatusAPI = require("../../../common/api/applicantLegalStatuses");
var enums = require('../../../common/enums');


module.exports = function ApplicationOrganisationController($scope, ngDialog) {
  var vm = this;
  vm.canEditTeamMembers = false;
  vm.organisation = {};
  vm.phoneNumberRegex = "[\(0-9\) \+]*";
  vm.urlRegex = "(https?://)?([a-zA-Z0-9]([a-zA-ZäöüÄÖÜ0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}";

  vm.OneYear = (new Date()).getFullYear() - 1;
  vm.TwoYear = (new Date()).getFullYear() - 2;
  vm.ThreeYear = (new Date()).getFullYear() - 3;

  vm.applicantId = '';

  vm.accountType = enums.accountType;
  vm.NumberOfPeople = enums.NumberOfPeople;
  vm.NumberOfPeopleLarge = enums.NumberOfPeopleLarge;
  vm.OrganisationManagementType = enums.OrganisationManagementType;
  vm.SocialMediaType = enums.SocialMediaType;
  vm.yesOrNo = enums.YesOrNo;

  vm.getDescription = function(enm, id){
    for (var i = 0; i < enm.length; i++) {
      var item = enm[i];
      if (item.id == id) return item.description;
    }
  }


  $scope.applicantUsers = [];
  //APPLICANT CLAIMS HAVE CHANGED AS OF 18/01/2018
  $scope.applicantClaimsTypes = [
    {
      id: '1',
      value: 'ApplicantAdmin',
      label: 'Applicant Admin',
      isSelected: false
    },
    {
      id:'2',
      value: 'ApplicantSuperAdmin',
      label: 'Applicant Super Admin',
      isSelected: false
    }
  ];

  vm.legalStatusSubmit = function(request) {
    request.applicantLegalStatuses.forEach(function(item) {
      if (item.internalRef=="registeredCharity" || item.internalRef=="cic" || item.internalRef=="cio") {
        request.charityNumber="";
      } else if (item.internalRef=="company_shares" || item.internalRef=="company_guarantee") {
        request.companyNumber="";
      }
    })
    return vm.submitInlineForm(request);
  }

  $scope.updateUserClaims = function(user){
    //now update the user claims for the applicant
    var promises = [];
    _.each(user.permissions, function(c){
      //only need to update changed values
      if(c.isChanged){
        //if c.isSelected == false, claim is removed. Otherwise claim is added
        promises.push(ApplicantAPI.ManageApplicantUserClaims(vm.applicantId, user.id, c.value, c.isSelected).then(function(){
          c.isChanged = false;
        }));
      }
    });
    return Promise.all(promises)
  }

  $scope.updateUserNumber = function(user) {
    return UserAPI.UpdateUserNumber(user.id, user.number);
  }

  $scope.updateUserOrganisationPosition = function (user) {
    return UserAPI.UpdateUserOrganisationPosition(user.id, user.organisationPosition, user.displayOrganisationPosition);
  }

  $scope.updateUserFinanceContact = function (user) {
    // Clear out other FinanceContact flags.
    if (user.isFinanceContact) {
      vm.applicantUsers.forEach(function(aUser) {
        if (aUser !== user) {
          aUser.isFinanceContact = false;
        }
      });
    }
    
    return ApplicantAPI.UpdateUserFinanceContact(vm.applicantId, user.id, user.isFinanceContact);
  }

  $scope.inviteUserToJoinApplicant = function(email){
    //send invitation
    return ApplicantAPI.InviteUserToJoinApplicant(vm.applicantId, email).then(function(){
      getInvites();
    });
  }
  $scope.removeUserFromApplicant = function(user){
    return ApplicantAPI.RemoveApplicantUser(vm.applicantId, user.id)
  }

  $scope.removeUserInvite = function(Id){
    return ApplicantAPI.RemoveApplicantInvitation(vm.applicantId, Id)
  }

  function getApplicantUsers(){
    return ApplicantAPI.GetApplicantUsers(vm.applicantId).then(function(applicantUsers){
      vm.applicantUsers = applicantUsers;
    });
  }

  function getInvites(){
    return ApplicantAPI.GetInvites(vm.applicantId).then(function(invites){
      $scope.invitedUsers = invites;
    });
  }

  vm.submitCoverPhoto = function(request){

    if(Array.isArray(request.coverPicture)) {
      var lowQualityImage = {};
      lowQualityImage = request.coverPicture[1];
      request.coverPicture = request.coverPicture[0];
      request.lowQualityCoverPicture = lowQualityImage;
      request.lowQualityCoverPictureUrl = encodeURI(window.conf.doc_repos_url + "get/" + encodeURIComponent((request.lowQualityCoverPicture.blobId).replace(/-/g, '')) + "/" + request.lowQualityCoverPicture.fileName);
    }
    if(request.coverPicture.blobId) {
      var url = encodeURI(window.conf.doc_repos_url + "get/" + encodeURIComponent((request.coverPicture.blobId).replace(/-/g, '')) + "/" + request.coverPicture.fileName);
      request.coverPictureUrl = url;
      return vm.submitInlineForm(request);
    } else {
      request.coverPictureUrl = null;
      return vm.submitInlineForm(request);
    }
  }

  vm.annualAccountsDocChanged = function(request){
    var aaDoc = request.annualAccounts;
    request.annualAccounts.blobId = aaDoc.id;
  }

  vm.businessPlansDocChanged = function(request){
    var aaDoc = request.businessPlans;
    request.businessPlans.blobId = aaDoc.id;
  }

  vm.recentBankStatementDocChanged = function(request){
    var rbsDoc = request.recentBankStatement;
    request.recentBankStatement.blobId = rbsDoc.id;
  }

  vm.submitSocialMedia = function(){
    vm.socialSubmitting = true;
    return vm.submitInlineForm(vm.organisation).then(function(){
      vm.socialSubmitting = false;
    })
  }

  vm.submitInlineForm = function (request) {
    return ApplicantAPI.UpdateApplicant(request).then(function(){
      return init();
    });
  }

  $scope.watchCatTreeItemsCategories = function(){
    $scope.$watchCollection('request.charitableCategories', function(value){
      value = value || [];
      $scope.form.catTreeItems.$setValidity('test', !!value.length);
    })
  }


  vm.submitPreviousFunding = function(request){
    // TODO: REFACTOR
    return Promise.all([
      ApplicantAPI.UpdateYearFunding(vm.organisation.id, currentYear - 1, request.oneYear),
      ApplicantAPI.UpdateYearFunding(vm.organisation.id, currentYear - 2, request.twoYears),
      ApplicantAPI.UpdateYearFunding(vm.organisation.id, currentYear - 3, request.threeYears),
    ]).then(function(result) {
      return init();
    })
  }

  var init = function() {

    return Promise.join(
      ApplicantAPI.GetApplicantDetails(),
      ApplicantLegalStatusAPI.GetApplicantLegalStatusTypes(),

      function(applicantDetails, orgStatusTypes) {
        vm.applicantOrgStatusTypes = orgStatusTypes.results

        if (applicantDetails){
          vm.applicantId = applicantDetails.applicantId;
          vm.organisation = applicantDetails;
          vm.canEditTeamMembers = auth.hasClaims([{ type: "ApplicantSuperAdmin", value: vm.applicantId }]);

          // // if applicantLegalStatuses exist, dont need defaults from API.
          // if (applicantDetails.applicantLegalStatuses && applicantDetails.applicantLegalStatuses.length) {
          //   vm.applicantOrgStatusTypes = applicantDetails.applicantLegalStatuses;
          // }

          return Promise.all([getApplicantUsers(), getInvites()]);
        }
      }
    );
  };
  init();
};
